import Permission from "./Permission.js";

export default class ResourcePermission {
    /** @type {string} */
    #resourceId;
    /** @type {string} */
    #resourceType;
    /** @type {Map<string, Permission>} */
    #permissions = new Map();

    /**
     * @param {string} id
     * @param {string} resourceType
     * @param {Permission[]} permissions
     */
    constructor(id, resourceType, permissions) {
        this.#resourceId = id;
        this.#resourceType = resourceType;
        permissions.forEach(p => this.#permissions.set(p.sid, p))
    }

    /** @returns {string}  */
    get id(){
        return this.#resourceId;
    }

    /** @returns {Map<string, Permission>}  */
    get permissions(){
        return this.#permissions;
    }

    /** @returns {string} */
    get resourceType(){
        return this.#resourceType;
    }

    /** @returns {boolean} */
    isBatchPermission(){
        return this.#resourceType === ResourcePermission.RESOURCE_TYPE.BATCH;
    }

    /** @returns {Permission[]} */
    getSortedPermissions(){
        const teams = [];
        const users = [];
        let publicTeamPermission = null;
        this.#permissions.forEach( value => {
            if (value.isTeamSid() && value.subject.isPublicTeam()){
                // we want to separate team with id === "p" (public team)
                publicTeamPermission = value;
            } else if (value.isTeamSid()) {
                teams.push(value)
            } else {
                users.push(value)
            }
        })
        teams.sort((a, b) => a.name.localeCompare(b.name));
        users.sort((a, b) => a.name.localeCompare(b.name));
        // we want Public team to go first because it may be the most important info - e.g. if user
        // accidentally shared private resource with the whole Internet
        if(publicTeamPermission)
            return [publicTeamPermission, ...teams, ...users];
        else return [...teams, ...users]
    }

    /** @returns {{level: number, id: string, type: string}[]} */
    #detPermissionsAccessLevels() {
        const result = [];
        this.#permissions.forEach(value => {
            result.push(value.createServerJson())
        })
        return result;
    }

    /** @returns {{accessLevel: {level: number, id: string, type: string}[], resource: string}} */
    createServerJson(){
        return {
            resource: this.#resourceId,
            accessLevels: this.#detPermissionsAccessLevels()
        }
    }

    /**
     * @param json
     * @param {string} resourceType
     * @returns {ResourcePermission}
     */
    static parseServerJson(json, resourceType) {
        return new ResourcePermission(json.resource, resourceType, Permission.parseServerJsonMany(json.accessLevel))
    }

    /**
     * @param json
     * @param {string} resourceType
     * @returns {ResourcePermission[]}
     */
    static parseServerJsonMany(json, resourceType) {
        return json.map(j => (ResourcePermission.parseServerJson(j, resourceType)));
    }

    static RESOURCE_TYPE = {
        INJECTION: "INJECTION",
        BATCH: "BATCH",
        ORG: "ORG",
        POST: "POST"
    }
}